<template>
    <v-container text-center fluid px-2>
        <!-- class="purple" -->
        <div class="loading" v-if="loading">
            <v-progress-circular
                    :size="50"
                    color="primary"
                    indeterminate
            ></v-progress-circular>
        </div>
        <div v-else>
            <v-card>
                <v-subheader>{{ formatDate(weekBefore) }} ~ {{ formatDate(today) }}</v-subheader>
                <v-layout justify-center>
                    <v-flex text-center xs12>
                        <v-simple-table class="elevation-6">
                            <thead>
                            <tr>
                                <th class="text-left" style="width:40%">Exercise</th>
                                <th class="text-left" style="width:30%">Weekly INOL</th>
                                <th class="text-left" style="width:30%">Last exercise</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(item, index) in exercises" :key="index">
                                <td class="text-left" style="width:40%">{{ item.name }}</td>
                                <td class="text-left" style="width:30%">{{ item.weeklyInol }}</td>
                                <td class="text-left" style="width:30%">{{ item.lastDate }}</td>
                            </tr>
                            </tbody>
                        </v-simple-table>
                    </v-flex>
                </v-layout>
            </v-card>
            <v-layout justify-center class="mt-2">
                <v-flex text-center xs12>
                    <v-card class="mx-auto">
                        <v-card-title class="subtitle-1">Total weekly INOL of a single exercise</v-card-title>
                        <v-card-text>
                            <div class="text-left">
                                &lt; 2 : Easy <br />
                                2 ~ 3 : Tough but doable<br />
                                3 ~ 4 : Very hard <br />
                                &gt; 4 : Unsustainable
                            </div>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </div>
    </v-container>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

import moment from 'moment';

export default {
    name: 'WeeklySummary',
    data: () => ({
        loading: true,
        user: JSON.parse(localStorage.getItem('user')),
        exercises: [],
        exerciseLogs: [],
        dayLogs: [],
        today: moment().format('YYYYMMDD'),
        weekBefore: moment()
            .add(-6, 'd')
            .format('YYYYMMDD'),
    }),
    beforeCreate() {
        /**
         * 새로고침 하거나, 브라우저를 껐다가 켜도 세션에서 사용자 정보를 읽어오기 때문에
         * beforeCreate에서 onAuthStateChanged를 등록해준다.
         */
        firebase.auth().onAuthStateChanged(user => {
            if (user) {
                if(this.user){
                    this.user = user;
                }else{
                    this.user = user;
                    this.fetchData();
                }
            } else {
                this.user = null;
                this.$router.push({path: 'calculator'});
            }
        });
    },
    created(){
        this.fetchData();
    },
    watch: {
        // 라우트가 변경되면 메소드를 다시 호출됩니다.
        $route: 'fetchData',
    },
    methods: {
        formatDate(date) {
            return moment(date).format('YY[.]MM[.]DD(ddd)');
        },
        fetchData() {
            if (!this.user) return;

            this.exerciseLogs.length = 0;

            firebase
                .firestore()
                .collection('user')
                .doc(this.user.uid)
                .collection('exercise')
                .get()
                .then(result => {
                    this.exercises.length = 0;
                    result.forEach(doc => {
                        let log = { name: doc.id, weeklyInol: 0.0 };
                        Object.assign(log, doc.data());
                        log.lastDate = moment(log.lastDate).format('MM[.]DD ddd');

                        this.exercises.push(log);
                    });
                    this.calculateWeeklyInol();
                    this.loading = false;
                })
                .catch(err => {
                    console.log(JSON.stringify(err));
                });
        },
        calculateWeeklyInol() {
            this.exercises.forEach(item => {
                firebase
                    .firestore()
                    .collection('exerciseLogs')
                    .doc(this.user.uid)
                    .collection('exercise')
                    .doc(item.name)
                    .collection('day')
                    .where('date', '>=', this.weekBefore)
                    .get()
                    .then(result => {
                        result.forEach(doc => {
                            item.weeklyInol = (Number.parseFloat(item.weeklyInol) + Number.parseFloat(doc.data().inol)).toFixed(2);
                        });
                    })
                    .catch(err => {
                        alert(JSON.stringify(err));
                    });
            });
        },
    },
};
</script>
